// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3VNhN","ScrollX":"Scroll_ScrollX__1e6Rb","ScrollY":"Scroll_ScrollY__2rme9"};